import { type ReactNode, createContext, useContext, useState } from 'react';
import { I18nextProvider } from 'react-i18next';

import { LOCALE_STORAGE_KEY, type Locale, getInitialLocale, isLocale } from './locale';

import { i18n } from './index';

interface LocaleContextValue {
  locale: Locale;
  setLocale: (l: Locale) => void;
}

const LocaleContext = createContext<LocaleContextValue>({ locale: 'en', setLocale: () => {} });

export function LocaleProvider({ children }: { children: ReactNode }) {
  const [locale, setLocaleState] = useState<Locale>(() =>
    isLocale(i18n.language) ? i18n.language : getInitialLocale()
  );

  const setLocale = (l: Locale) => {
    void i18n.changeLanguage(l);
    localStorage.setItem(LOCALE_STORAGE_KEY, l);
    setLocaleState(l);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <LocaleContext.Provider value={{ locale, setLocale }}>{children}</LocaleContext.Provider>
    </I18nextProvider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const useLocale = () => useContext(LocaleContext);
